<template>
  <div class="zj-emergency-operations-left-panel select-none">
    <div class="zj-emergency-operations-search-box">
      <input
        class="zj-emergency-operations-search-box-input"
        v-model="searchText"
        @click="searchTextChanged"
        type="text"
        placeholder="请输入地图中资源点名称"
      />
      <div class="zj-emergency-operations-search-box-btn" v-on:click="searchPOI"></div>
    </div>
    <div class="zj-emergency-operations-video" :class="{'hiddenBg':isHidden}">
      <VideoMonitorPanel  @changeStyle="changeStyle"/>
    </div>
    <!-- <div class="zj-emergency-operations-realtime-call">
      <RealtimeCall v-bind:ExecutId="ExecutId" :roomId="roomId" :pwd="pwd" />
    </div> -->

    <div v-if="searchLayerVislble" class="search-upper-layer">
      <div class="zj-emergency-operations-search-shrink">
        <div class="shrink-btn select-none" v-on:click="shrink">收起</div>
      </div>
      <div class="zj-emergency-operations-search-area-container">
        <PoiSearchResult
          :center="center"
          :searchText="searchText"
          isEmergencyOperations="true"
          class="zj-emergency-operations-search-area"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VideoMonitorPanel from "./Component-VideoMonitorPanel";
// import RealtimeCall from "./Component-RealtimeCall";

import PoiSearchResult from "./../../OneMap/PoiSearchResult";

export default {
  name: "ZJEmergencyOperationsLeftPanel",
  componentName: "ZJEmergencyOperationsLeftPanel",
  props: {
    center: {
      type: Object,
      default: function () {
        return [0, 0];
      },
    },
    ExecutId: {
      type: String,
      required: true
    },
    roomId: {
      type: String,
    },
    pwd: {
      type: String,
    },
  },
  components: {
    VideoMonitorPanel,
   // RealtimeCall,
    PoiSearchResult,
  },
  data: function () {
    return {
      isShrink: false,
      searchText: "",
      searchLayerVislble: false,
       isHidden:false
    };
  },
  methods: {
    changeStyle(flag){
      this.isHidden = flag
    },
    searchTextChanged: function () {
      this.searchLayerVislble = true;
    },
    fullscreen: function () {
      this.isFullScreen = !this.isFullScreen;
      this.theme.header.visiable = !this.isFullScreen;
      this.theme.sidemenu.visiable = !this.isFullScreen;
    },
    shrink: function () {
      this.searchLayerVislble = false;
    },
    searchPOI: function () {
      this.$emit("searchPoi", this.searchText);
    },
  },
  watch: {
    searchText: function () {
      this.$emit("searchPoi", this.searchText);
    },
  },
};
</script>